<template>
  <div class="main">
    <div>
      <Header/>
      <div class="content">
        <div v-for="(item,index) in data.targets" v-bind:key="index" class="main-button" v-on:click="itemClick(item)">
          {{ item.label }}
          <div class="button-desc">{{ item.desc }}</div>
        </div>
      </div>
      <div class="tips">
        <span style="  font-weight: 500;">IOS下载说明</span><br/>
        <div style="text-align: left;margin-top: 10px;font-size: 13px" v-html="tips()">
        </div>
      </div>
      <div class="bottom">
        <div class="us">{{ bottomTips() }}</div>
      </div>
      <ContactUs/>
    </div>
    <div v-if="isLimit()"
         style="position: fixed;z-index: 10;top:0;bottom:0;left:0;right:0;background: rgba(0,0,0,0.9);text-align: center">
      <span style="color: #FFF;text-align: center;display: block;margin-top: 200px;margin-bottom: 30px">
        <h3>在该浏览器中无法进行下载<br/>请使用 Safari 打开进行下载</h3>
      </span>
      <el-button v-on:click="copyLink" style="margin-bottom: 30px" type="primary" onclick="">点击复制链接地址
      </el-button>
      <div style="color: #FFF;line-height: 30px">
        <p>1. 点击上方复制链接地址</p>
        <p>2. 打开Safari浏览器</p>
        <p>3. 在Safari地址栏中进行粘贴</p>
      </div>
    </div>
  </div>
</template>

<script>

import Header from '@/components/Header';
import ContactUs from "../components/contact-us";
import {Loading} from "element-ui";
import axios from "axios";
import OpenInstall from "@/lib/OpenInstall";

export default {
  name: "ios-download",
  components: {
    Header,
    ContactUs,
  },
  data() {
    return {
      data: {}
    };
  },
  created() {
    let configLoadingInstance = Loading.service({});
    axios.post("/api/system/system/web/download-info/ios", {}).then((res) => {
      if (res.code !== 200) return;
      this.$data.data = res.data;
      console.log(this.$data.data);
      // 打开下载页面
      // OpenInstall.install();
    }).finally(() => configLoadingInstance.close());
  },
  methods: {
    // 是否限制
    isLimit() {
      return /QQBrowser/.test(navigator.userAgent) || /baidu/.test(navigator.userAgent);
    },
    // 提示信息
    tips() {
      return this.$data.data.tips.toString().replaceAll("\n", "<br/>");
    },
    // 底部提示信息
    bottomTips() {
      return this.$data.data.bottomTips.toString().replaceAll("\n", "<br/>");
    },
    // 点击事件
    itemClick(item) {
      let inviteCode = this.$route.query.invitationCode;
      if (inviteCode) this.$copyText(inviteCode.toString());

      // 如果打开APP
      if (item.openApp) {
        OpenInstall.install();
        return;
      }

      // 如果URL跳转
      if (item.url) {
        if (item.url.startsWith("/")) this.$router.push({path: item.url, query: {...this.$route.query, "url": location.href}});
        else {
          location.href = item.url;
        }
        return;
      }

      alert(item.desc)
    },
    // 复制链接点击
    copyLink() {
      this.$copyText(location.href).then(e => {
        alert('复制成功')
        console.log(e)
      });
    }
  }
}
</script>

<style scoped>
.main {
  background: linear-gradient(270deg, rgba(118, 75, 248, 1) 0%, rgba(187, 58, 246, 1) 100%);
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.content {
  text-align: center;
  margin-top: 50px;
}

.button-desc {
  font-size: 12px;
  font-weight: 400;
}

.main-button {
  margin-top: 30px;
  font-size: 20px;
  font-weight: 500;
  background: linear-gradient(180deg, #FFE4FB 0%, #FFFFFF 100%);
  color: #EF0AF4;
  width: 80%;
  padding: 10px 0;
  display: inline-block;
  border-radius: 30px;
}

.us {
  color: #FFF;
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
}

.tips {
  padding: 40px;
  color: #FFF;
  text-align: center;
  font-size: 16px;
}

.bottom {
  position: absolute;
  bottom: 20px;
  text-align: center;
  color: #FFF;
  left: 0;
  right: 0;
}
</style>
